export enum ActionTypeEnum {
  GLOBAL,
  SINGLE
}
